import "@/styles/portal/design-js/label.js";

export type ProductLabel = {
	productName: string;
	productCode: string;
	factoryBarcode?: string;
	labelQuantity: number;
	sellingPriceByStoreName: Record<string, number>;
	storeName?: string;
	expiryDate?: string;
	storageMethod?: string;
	shelfLifeDays?: number;
	subCategoryName?: string;
};

// Field names label.js reads.
type DesignLabelItem = {
	n: string;
	code: string;
	ean?: string;
	qty: number;
	prices: Record<string, number>;
	toko?: string;
	exp?: string;
	simpan?: string;
	masa?: number;
	sub?: string;
};

type DesignLabelOptions = { toko?: string; size?: string };

type DesignLabelPrinter = {
	open: (items: DesignLabelItem[], options?: DesignLabelOptions) => void;
	internal: (productCode: string) => string;
	svg: (barcode: string) => string;
};

declare global {
	interface Window {
		K3Label?: DesignLabelPrinter;
	}
}

// Design dialog, printed labels match.
export const openLabelPrinter = (
	productLabels: ProductLabel[],
	defaultStoreName?: string,
) =>
	window.K3Label?.open(
		productLabels.map((productLabel) => ({
			n: productLabel.productName,
			code: productLabel.productCode,
			ean: productLabel.factoryBarcode ?? "",
			qty: productLabel.labelQuantity,
			prices: productLabel.sellingPriceByStoreName,
			toko: productLabel.storeName,
			exp: productLabel.expiryDate,
			simpan: productLabel.storageMethod,
			masa: productLabel.shelfLifeDays,
			sub: productLabel.subCategoryName,
		})),
		{ toko: defaultStoreName },
	);

export const resolveProductBarcode = (
	productCode: string,
	factoryBarcode?: string,
) => factoryBarcode || window.K3Label?.internal(productCode) || "";

export const barcodeImageUri = (barcode: string) =>
	window.K3Label
		? `data:image/svg+xml;utf8,${encodeURIComponent(window.K3Label.svg(barcode))}`
		: "";
